import styles from './MenuHeader.module.scss';
import { Props } from './MenuHeader.types';

const MenuHeader = ({ label }: Props) => {
  return <p className={styles.container}>{label}</p>;
};

export default MenuHeader;
